<template>
	<el-container id="header" :class="!navBarFixed? 'navBarTop' :''">
		<transition name="logoTop">
			<div id="logoBg" :style="bgImg"> <!-- v-show="navBarFixed" -->
				<!-- <img src="../../assets/logotop.jpg" ref="logoTop"/> -->
				<div class="logo">
					<img src="../../assets/logo.png" alt="">
				</div>
				<div class="wechat">
					<img src="../../assets/wechatcode.jpg" alt="">
				</div>
			</div>
		</transition>
    <el-header height="80px">
		<!-- <img src="../../assets/leftLogo.png" class="leftLogo"/> -->
      <div class="navList">
        <div class="navList-btn" @click="menuBtnT">
          <span class="iconfont">&#xe61e;</span>
        </div>
        <div class="menu">
          <ul>
            <li v-for="item in $t('menu.list')">
              <div>
                <router-link :to="item.href">{{item.name}}</router-link>
                <router-link :to="item.href">{{item.name}}</router-link>
              </div>
            </li>
          </ul>
					<div class="language">
						<div class="t">
							<span>中/EN</span>
							<span>中/EN</span>
						</div>
						<div class="b">
							<b :class="menu.language? 'active' :''" @click="langCN">中</b>
							<b :class="!menu.language? 'active' :''" @click="langEN">EN</b>
						</div>
					</div>
        </div>
        <transition name="fade">
          <div class="menu-m" v-show="menu.show">
            <transition name="fadeBtn">
              <div v-show="menu.show" class="menu-btn" @click="menuBtnF">
                <span class="t"></span>
                <span class="b"></span>
              </div>
            </transition>
            <transition name="fadeList">
              <ul v-show="menu.show">
                <li v-for="item in $t('menu.list')" @click="menuBtnF">
                  <router-link :to="item.href">{{item.name}}</router-link>
                </li>
              </ul>
            </transition>
          </div>
        </transition>
      </div>
    </el-header>
	</el-container>

</template>

<script>
export default {
	name: 'navList',
	data() {
		return {
			menu:{
				show:false,
				language: true
			},
      bgImg: {
        backgroundImage: "url("+require("../../assets/bg_head.jpg")+")"
      },
      navBarFixed: true
		};
	},
	mounted(){
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll);
		var logoTop = this.$refs.logoTop;
		//console.log(logoTop);
		var language = sessionStorage.getItem('language');
		if(language != 'null'&& language != null){
			this.menu.language = false;
		};
	},
	methods:{
		menuBtnT (e) {
			this.menu.show = true
		},
		menuBtnF (e) {
			this.menu.show = false
		},
    watchScroll () {
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			//  当滚动超过 148 时，实现吸顶效果
			if (scrollTop > 0) {
				this.navBarFixed = false
			} else {
				this.navBarFixed = true
			}
		},
		langCN (e) {
			sessionStorage.setItem('language',null);
			sessionStorage.setItem('locale','cn');
			//this.$i18n.locale = 'cn';
			location.reload();
		},
		langEN (e) {
			sessionStorage.setItem('language','en');
			sessionStorage.setItem('locale','en');
			//this.$i18n.locale = 'en';
			location.reload();
		}
	},
	created(){

	}
}
</script>

<style>
#logoBg{
  height: 150px;
	background-repeat: no-repeat;
	background-size: cover;
	padding: 0 50px;
	position: relative;
}
.navBarTop{
	/* position: fixed !important; */
}
#header{
  position: relative;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 98;
  /* padding: 0 30px; */
}
.el-header{
	width: 100%;
	display: flex;
	justify-content: flex-end;
  padding: 0 50px;
  background-image: linear-gradient(#c74206, #EB6A30,#c74206);
  /* background: #EB6A30; */
	box-sizing: border-box;
}
.logo {
	width: 280px;
	position: absolute;
	left: 50px;
	top: 50%;
	transform: translateY(-50%);
}
.logo img{
	width: 100%;
	display: block;
}
.wechat{
	width: 120px;
	position: absolute;
	right: 50px;
	top: 50%;
	transform: translateY(-50%);
}
.wechat img{
	width: 100%;
	display: block;
}
.leftLogo{
	height: 70px;
	padding: 5px 0;
	width: 150px;
	position: absolute;
	left: 50px;
}
.navList{
	position: relative;
}
.navList .navList-btn{
	width: 30px;
	height: 30px;
	display: none;
	position: absolute;
	top: 50%;
	right: 0;
	transform: translateY(-50%);
}
.navList .navList-btn span{
	font-size: 20px;
	line-height: 30px;
	color: #6b6b6b;
}
.navList .menu{
	height: 100%;
	display: flex;
}
.navList .menu ul{
	display: flex;
	height: 100%;
}
.navList .menu ul li{
  width: 100px;
	height: 100%;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.navList .menu ul li div{
  position: absolute;
  top: 0;
  left: 0;
  transition: all .3s ease;
}
.navList .menu ul li a{
  width: 100px;
  height: 80px;
	text-decoration: none;
	font-size: 16px;
  display: block;
  box-sizing: border-box;
  line-height: 80px;
  /* background-color: #EB6A30; */
  color: #FFF;
}
.navList .menu ul li a:last-child{
  /* background-color: #ff9d45; */
	background-image: linear-gradient(#EB6A30, #ff9d45,#EB6A30);
  color: #fff;
}
.navList .menu ul li a:first-child.router-link-exact-active
,.navList .menu ul li a:first-child.router-link-active{
	color: #fff;
  /* background-color: #ff9d45; */
	background-image: linear-gradient(#EB6A30, #ff9d45,#EB6A30);
}
.navList .menu ul li:hover div{
  top: -80px;
}
.navList .menu .language{
	width: 100px;
	height: 100%;
	position: relative;
	cursor: pointer;
}
.navList .menu .language .t{
	width: 100%;
	height: 80px;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
	overflow: hidden;
}
.navList .menu .language span{
	display: block;
	width: 100%;
	line-height: 80px;
	text-align: center;
	font-size: 16px;
	color: #fff;
	/* background-color: #EB6A30; */
	transition: all .3s ease;
}
.navList .menu .language span:last-child{
	/* background: #ff9d45; */
	background-image: linear-gradient(#EB6A30, #ff9d45,#EB6A30);
}
.navList .menu .language .b{
	position: absolute;
	width: 150px;
	top: 80px;
	right: 0;
	background-color: #ff9d45;
	z-index: 1;
	opacity: 0;
	height: 0;
	overflow: hidden;
	transition: all .8s ease;
}
.navList .menu .language .b b{
	font-size: 18px;
	color: #6b6b6b;
	line-height: 58px;
	font-weight: normal;
	padding: 5px;
	transition: all .8s ease;
}
.navList .menu .language .b b.active{
	color: #fff;
}
.navList .menu .language:hover .t span:first-child{
	margin-top: -80px;
}
.navList .menu .language:hover .b{
	height: 58px;
	opacity: 1;
}

.navList .menu-m{
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 99;
	background: rgba(0,0,0,0.4);
	display: none;
}
.navList .menu-m ul{
	position: absolute;
	top: 0;
	right: 0;
	width: 60%;
	height: 100%;
	background: #FFFFFF;
}
.navList .menu-m ul li{
	display: block;
	width: 100%;
	height: auto;
	border-bottom: 1px solid #f0f0f0;
}
.navList .menu-m ul li a{
	width: 100%;
	display: block;
	padding: 15px 0;
	text-decoration: none;
	color: #101010;
	position: relative;
}
.navList .menu-m ul li a::after{
	content: "";
	position: absolute;
	width: 5px;
	height: 5px;
	border-radius: 50%;
	border: 1px solid #999;
	top: 50%;
	left: 20%;
	transform: translateY(-50%);
}
.navList .menu-m ul li .router-link-exact-active::after
,.navList .menu-m ul li .router-link-active::after{
	background-color: #999;
}
.navList .menu-m ul li:last-child{
	display: none;
}
.navList .menu-m .menu-btn{
	width: 30px;
	height: 30px;
	display: block;
	position: absolute;
	right: 65%;
	top: 30px;
}
.navList .menu-m .menu-btn span{
	display: block;
	width: 30px;
	height: 2px;
	background: #FFFFFF;
	position: absolute;
	top: 14px;
	left: 0;
}
.navList .menu-m .menu-btn .t{
	transform: rotate(45deg);
}
.navList .menu-m .menu-btn .b{
	transform: rotate(-45deg);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fadeBtn-enter-active, .fadeBtn-leave-active {
  transition: all 1s;
}
.fadeBtn-enter, .fadeBtn-leave-to {
	transform: rotate(90deg) scale(1.5);
  opacity: 0;
}
.fadeList-enter-active, .fadeList-leave-active {
  transition: all 1s;
}
.fadeList-enter, .fadeList-leave-to {
	transform: translateX(100%);
	opacity: 0;
}

.logoTop-enter-active, .logoTop-leave-active {
  transition: all 1s;
}
.logoTop-enter, .logoTop-leave-to {
	margin-top: -100%;
}

@media (max-width: 1200px){
	#logoBg{
		height: 160px;
	}
	.leftLogo{
		height: 70px;
		padding: 5px 0;
		width: 150px;
		position: absolute;
		left: 50px;
	}
}

@media (max-width: 992px){
	.el-header{
		padding: 0 10px;
	}
  .logo{
		width: 150px;
    left: 10px;
  }
	.wechat{
		width: 100px;
		right: 10px;
	}
	.leftLogo{
		height: 70px;
		padding: 5px 0;
		width: 100px;
		position: absolute;
		left: 10px;
	}
	.navList .menu{
		display: none;
	}
	.navList .menu-m{
		display: block;
	}
	.navList .navList-btn{
		display: block;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/navlist.vue